"use client";

const UTM_SOURCE_PARAM = "utm_source";
export const USER_SOURCE_KEY = "user_source";

export function getUserSource(): string | null {
  if (typeof window === "undefined") return null;

  const stored = sessionStorage.getItem(USER_SOURCE_KEY);
  if (stored !== null && stored !== undefined && stored !== "") return stored;

  const param = new URLSearchParams(window.location.search).get(
    UTM_SOURCE_PARAM
  );

  if (param !== null && param !== undefined && param !== "") {
    sessionStorage.setItem(USER_SOURCE_KEY, param);
    return param;
  }

  return null;
}
